/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

// Google Map
function initMap( $el ) {
    // Find marker elements within map.
    var $markers = $el.find('.marker');
    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );
    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });
    centerMap( map );
    // Return map instance.
    return map;
}
function initMarker( $marker, map ) {
    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };
    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });
    // Append to reference for later use.
    map.markers.push( marker );
    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){
        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });
        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}
function centerMap( map ) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });
    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );
    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}


  function scrollTo() {
    (function(document, history, location) {
      var HISTORY_SUPPORT = !!(history && history.pushState);
      var anchorScrolls = {
        ANCHOR_REGEX: /^#[^ ]+$/,
        OFFSET_HEIGHT_PX: 82,
        /**
         * Establish events, and fix initial scroll position if a hash is provided.
         */
        init: function() {
          this.scrollToCurrent();
          $(window).on('hashchange', $.proxy(this, 'scrollToCurrent'));
          $('body').on('click', 'a', $.proxy(this, 'delegateAnchors'));
        },
        /**
         * Return the offset amount to deduct from the normal scroll position.
         * Modify as appropriate to allow for dynamic calculations
         */
        getFixedOffset: function() {
          return this.OFFSET_HEIGHT_PX;
        },
        /**
         * If the provided href is an anchor which resolves to an element on the
         * page, scroll to it.
         * @param  {String} href
         * @return {Boolean} - Was the href an anchor.
         */
        scrollIfAnchor: function(href, pushToHistory) {
          var match, anchorOffset;
          if(!this.ANCHOR_REGEX.test(href)) {
            return false;
          }
          match = document.getElementById(href.slice(1));
          if(match) {
            anchorOffset = $(match).offset().top - this.getFixedOffset();
            $('html, body').animate({ scrollTop: anchorOffset});
            // Add the state to history as-per normal anchor links
            if(HISTORY_SUPPORT && pushToHistory) {
              history.pushState({}, document.title, location.pathname + href);
            }
          }
          return !!match;
        },
        /**
         * Attempt to scroll to the current location's hash.
         */
        scrollToCurrent: function(e) {
          if(this.scrollIfAnchor(window.location.hash) && e) {
          	e.preventDefault();
          }
        },
        /**
         * If the click event's target was an anchor, fix the scroll position.
         */
        delegateAnchors: function(e) {
          var elem = e.target;
          if(this.scrollIfAnchor(elem.getAttribute('href'), true)) {
            e.preventDefault();
          }
        }
      };
    	$(document).ready($.proxy(anchorScrolls, 'init'));
    })(window.document, window.history, window.location);
  }

  function menuBg() {
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 200) {
            $(".fixed-top").addClass("bgwhite");
        } else {
            $(".fixed-top").removeClass("bgwhite");
        }
    });
  }

  function burger() {
    $('.nav-burger').click(function(){
      $(this).toggleClass('open');
      $(this).closest('.mob-height').find('svg').toggleClass('open');
      $(this).closest('.fixed-top').toggleClass('bg-color');
      $('.nav-primary').toggleClass('d-block');
      $('.mobile-text').toggleClass('d-block');
    });
  }

  function modal() {
    let a_href = $(this).find('.modal-link a').attr('href');
    var itemId = a_href.substring(1);
    $('.modal-link a').attr({
      'type' : '',
      'data-toggle' : 'modal',
      'data-target' : a_href
    }).removeAttr('href');
    $('.modal').attr('id', itemId);
  }

  function topFunction() {
    $("a[href='#top']").click(function(e) {
      e.preventDefault();
      $("html, body").animate({ scrollTop: 0 }, "slow");
      return false;
    });
  }

  function fadeToggler() {
    $('.secondLang').hide();
    var fader = function () {
      $('.currentLang').fadeToggle(800, 'swing');
      $('.secondLang').fadeToggle(800, 'swing');
    };
      setInterval(fader, 6000);
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        $(window).ready(modal);
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        burger();
        scrollTo();
        topFunction();
        $(window).scroll(menuBg);
        function showMessage() {
          document.getElementById('display').innerHTML = 
                      console.log('hallo welt');
      }
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {

        fadeToggler();
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        $('.slider').slick({
          'arrows' : false,
          'dots' : true
        });
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    page_template_template_contact: {
      init: function() {
    },
    finalize: function() {
      $('.acf-map').each(function(){
          var map = initMap($(this));
        });
      }
    },
    page_template_template_clients: {
      init: function() {
    },
    finalize: function() {
      if(window.location.hash) {
        $('.sucess_message').show();
        $('form').hide().prev().hide();
        } else {
          $('.sucess_message').hide();
        }
      }
    }, 
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
